<div class="ui-modal">
       <div class="header flex-row space-between-center">
              {{'FLOW_CHART.SETTINGS'|translate}}
              <span class="ui-icon-close c-p"
                    mat-dialog-close>
              </span>
       </div>

       <div class="body">
              <div [formGroup]="dataForm"
                   class="flex-col start-start gap-16 w-100">
                     <input class="ui-input name-input w-100"
                            formControlName="name">
                     <app-tag-filter formControlName="tags"></app-tag-filter>
              </div>
       </div>

       <div class="footer flex-row end-center">
              <ui-button type="default"
                         [text]="'COMMON.CANCEL'|translate"
                         (clickAction)="close()">
              </ui-button>

              <ui-button type="primary"
                         [text]="'COMMON.SAVE'|translate"
                         [disabled]="dataForm.invalid"
                         (clickAction)="save()">
              </ui-button>
       </div>
</div>